import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function AddManager() {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}managers/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ ...formData, _method: "POST" }),
        }
      );

      const result = await response.json();
      console.log(result);
      if(result.success){
        alert(result.message || "Profile submitted!");
        navigate(process.env.PUBLIC_URL + "/viewManagers");
      }else{
        alert(result.error);
      }    
      
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong!");
    }
    setLoading(false);
  };
  return (
    <div className="container mt-5">
      <Link
        to={`${process.env.PUBLIC_URL}/viewManagers`}
        className="btn btn-secondary mb-3"
      >
        ← Back to Managers
      </Link>
      <div className="card shadow p-4">
        <h2 className="mb-4 text-center">Add Manager</h2>
        <form onSubmit={handleSubmit}>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Name with surname</label>
              <input
                className="form-control"
                name="name"
                required
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Phone Number</label>
              <input
                type="text"
                className="form-control"
                name="phone_number"
                required
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Alternative Number</label>
              <input
                type="text"
                className="form-control"
                name="phone_number2"
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                name="email"
                required
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Password</label>
              <input
                className="form-control"
                type="password"
                name="password"
                required
                onChange={handleChange}
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary w-100 mt-4"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}
